import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { usePartnerAuth } from '../auth';

const navItem = 'px-3 py-1.5 rounded-lg text-sm font-medium transition-colors';
const activeCls = 'bg-raspberry-50 text-raspberry-700';
const inactiveCls = 'text-ink-secondary hover:bg-surface-page hover:text-ink';

const isImpersonation = () => localStorage.getItem('partner_mahi_is_impersonation') === 'true';

const stopImpersonation = () => {
  localStorage.removeItem('partner_mahi_token');
  localStorage.removeItem('partner_mahi_is_impersonation');
  localStorage.removeItem('partner_mahi_brand_name');
  window.close(); // close the tab; admin panel stays open
};

export default function Shell() {
  const { partner, signOut } = usePartnerAuth();
  const impersonating = isImpersonation();

  return (
    <div className="min-h-screen">
      {/* Admin impersonation banner */}
      {impersonating && (
        <div className="flex items-center justify-between bg-raspberry-600 px-6 py-2 text-sm text-white">
          <span>
            🔍 <strong>Admin preview</strong> — you are viewing{' '}
            <strong>{partner?.brand_name || localStorage.getItem('partner_mahi_brand_name')}</strong>'s partner account.
            This session expires in 1 hour.
          </span>
          <button
            onClick={stopImpersonation}
            className="ml-4 rounded border border-white/40 px-2.5 py-0.5 text-xs font-medium hover:bg-white/20"
          >
            Exit preview
          </button>
        </div>
      )}
      <header className="border-b border-hairline bg-surface">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
          <div className="flex items-center gap-6">
            {/* Brand logo */}
            <span className="font-serif text-base text-ink">
              <span className="text-raspberry-600">mahi</span>
              <span className="text-ink-secondary text-sm font-sans">.fashion partners</span>
            </span>
            <nav className="flex items-center gap-1">
              <NavLink
                to="/dashboard"
                className={({ isActive }) => `${navItem} ${isActive ? activeCls : inactiveCls}`}
              >
                Dashboard
              </NavLink>
              <NavLink
                to="/products"
                className={({ isActive }) => `${navItem} ${isActive ? activeCls : inactiveCls}`}
              >
                Products
              </NavLink>
              {/* Analytics added in M5 */}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right leading-tight">
              <div className="text-sm font-medium text-ink">{partner?.brand_name}</div>
              <div className="text-xs text-ink-muted">{partner?.brand_domain}</div>
            </div>
            <button
              onClick={signOut}
              className="rounded-lg border border-hairline px-2.5 py-1.5 text-xs font-medium text-ink-secondary hover:bg-surface-page hover:text-ink"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
